import { Sparkles } from 'lucide-react'
import type { SuggestPromptFactory } from '@/api/endpoints/factories'
import styles from './SuggestPromptButton.module.scss'

export interface SuggestPromptButtonProps {
  factory: SuggestPromptFactory
  language: 'pt-br' | 'en' | 'both'
  channel: string
  pending: boolean
  error: unknown
  onClick: () => void
}

/**
 * Inline "Gerar prompt" button rendered below each factory's Prompt
 * customizado textarea. Hits ``/factories/{factory}/suggest-prompt`` via
 * the parent's ``useSuggestPrompt`` mutation; the parent owns the
 * mutation so React Hook Form's ``setValue`` can write the result.
 */
export function SuggestPromptButton({
  factory: _factory,
  language: _language,
  channel,
  pending,
  error,
  onClick,
}: SuggestPromptButtonProps) {
  const disabled = pending || !channel
  // `message` é `unknown`: se vier um objeto, `String()` produzia o literal
  // "[object Object]" na tela em vez de uma mensagem. Estreitar para string
  // antes de exibir troca isso por texto vazio, que o JSX abaixo já trata.
  const rawMessage = error && typeof error === 'object' && 'message' in error ? (error as { message?: unknown }).message : undefined
  const errorMessage = typeof rawMessage === 'string' ? rawMessage : ''
  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.button}
        onClick={onClick}
        disabled={disabled}
        aria-label="Gerar um novo prompt automaticamente"
      >
        <Sparkles aria-hidden />
        {pending ? 'Gerando...' : 'Gerar prompt'}
      </button>
      <span className={styles.hint}>
        Usa os temas existentes + seus prompts recentes como referência.
      </span>
      {errorMessage ? <span className={styles.error}>{errorMessage}</span> : null}
    </div>
  )
}
